import { render, staticRenderFns } from "./AlignmentsDesktop.vue?vue&type=template&id=be5c920c&scoped=true&"
import script from "./AlignmentsDesktop.vue?vue&type=script&lang=ts&"
export * from "./AlignmentsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./AlignmentsDesktop.vue?vue&type=style&index=0&id=be5c920c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5c920c",
  null
  
)

export default component.exports